<template>
  <div class="mc-filtros">
    <div class="mc-filtros__two-col">
      <div class="mc-filtros__loja-wrap">
        <div class="mc-filtros__loja-row">
          <span class="mc-filtros__label">Selecionar loja</span>
          <b-form-select
            :value="chatSelecionado"
            :options="storeOptions"
            class="mc-filtros__select"
            :disabled="disabled || !storeOptions.length"
            @input="$emit('update:chatSelecionado', $event)"
          />
        </div>
      </div>

      <div
        class="mc-filtros__sep"
        aria-hidden="true"
      />

      <div class="mc-filtros__periodo">
        <div class="mc-filtros__periodo-head">
          <span class="mc-filtros__periodo-title">Período</span>
          <span class="mc-filtros__periodo-req">obrigatório</span>
        </div>

        <div
          class="mc-filtros__pills"
          role="group"
          aria-label="Presets de período"
        >
          <button
            v-for="p in presets"
            :key="p.id"
            type="button"
            class="mc-filtros__pill"
            :class="{ 'mc-filtros__pill--active': periodoPresetId === p.id }"
            @click="$emit('preset', p.id)"
          >
            {{ p.label }}
          </button>
        </div>

        <div class="mc-filtros__dates-row">
          <div class="mc-filtros__date-col">
            <span class="mc-filtros__date-lbl">Data inicial</span>
            <b-form-datepicker
              :value="periodoInicio"
              locale="pt-BR"
              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
              start-weekday="1"
              class="mc-filtros__datepicker w-100"
              menu-class="mc-filtros-datepicker-popover"
              label-no-date-selected="Selecionar"
              :state="null"
              :disabled="disabled"
              @input="$emit('update:periodoInicio', $event)"
            />
          </div>

          <span
            class="mc-filtros__date-arrow"
            aria-hidden="true"
          >→</span>

          <div class="mc-filtros__date-col">
            <span class="mc-filtros__date-lbl">Data final</span>
            <b-form-datepicker
              :value="periodoFim"
              locale="pt-BR"
              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
              start-weekday="1"
              class="mc-filtros__datepicker w-100"
              menu-class="mc-filtros-datepicker-popover"
              label-no-date-selected="Selecionar"
              :state="null"
              :disabled="disabled"
              @input="$emit('update:periodoFim', $event)"
            />
          </div>
        </div>

        <div class="mc-filtros__apply-row">
          <button
            type="button"
            class="mc-filtros__apply-btn"
            :disabled="disabled"
            @click="$emit('aplicar-periodo')"
          >
            <b-spinner
              v-if="carregando"
              small
              class="mc-filtros__apply-spin"
            />
            Aplicar período
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltrosRelatorioBot',
  props: {
    storeOptions: {
      type: Array,
      default: () => [],
    },
    chatSelecionado: {
      type: [String, Number, null],
      default: null,
    },
    periodoPresetId: {
      type: String,
      default: 'ultimos7',
    },
    periodoInicio: {
      type: [Date, String, null],
      default: null,
    },
    periodoFim: {
      type: [Date, String, null],
      default: null,
    },
    carregando: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      presets: [
        { id: 'ultimos7', label: 'Últimos 7 dias' },
        { id: 'ultimos15', label: 'Últimos 15 dias' },
        { id: 'ultimos31', label: 'Últimos 31 dias' },
        { id: 'personalizado', label: 'Personalizado' },
      ],
    }
  },
}
</script>

<style scoped>
.mc-filtros {
  background: var(--mc-surface);
  border-radius: var(--mc-radius-lg);
  box-shadow: var(--mc-shadow-md);
  border: 1px solid var(--mc-border);
  padding: 1.35rem 1.5rem 1.5rem;
  margin-bottom: 2rem;
  transition: box-shadow 0.22s ease;
}

.mc-filtros:hover {
  box-shadow: 0 12px 32px rgba(93, 42, 140, 0.09);
}

.mc-filtros__two-col {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.mc-filtros__loja-wrap {
  width: 100%;
}

.mc-filtros__loja-row {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.mc-filtros__sep {
  flex-shrink: 0;
  background: var(--mc-border);
  height: 1px;
  width: 100%;
  margin: 1.25rem 0 1.15rem;
}

@media (min-width: 992px) {
  .mc-filtros__two-col {
    flex-direction: row;
    align-items: flex-start;
    gap: 1.5rem;
  }

  .mc-filtros__loja-wrap {
    flex: 0 0 260px;
    width: auto;
    max-width: 300px;
  }

  .mc-filtros__sep {
    width: 1px;
    height: auto;
    align-self: stretch;
    min-height: 8rem;
    margin: 0;
  }

  .mc-filtros__periodo {
    flex: 1 1 auto;
    min-width: 0;
  }
}

.mc-filtros__label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--mc-text-soft);
}

.mc-filtros__select {
  border-radius: var(--mc-radius-sm) !important;
  border: 1px solid var(--mc-border) !important;
  min-height: 46px;
  font-weight: 600;
  color: var(--mc-text);
  background-color: var(--mc-surface-soft) !important;
}

.mc-filtros__periodo-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.mc-filtros__periodo-title {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--mc-purple);
}

.mc-filtros__periodo-req {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--mc-text-muted);
}

.mc-filtros__pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.mc-filtros__pill {
  border: 1px solid var(--mc-border);
  background: #fff;
  color: var(--mc-text);
  font-size: 0.84rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: var(--mc-radius-pill);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.mc-filtros__pill:hover {
  border-color: rgba(123, 63, 228, 0.35);
  color: var(--mc-purple);
}

.mc-filtros__pill--active {
  background: linear-gradient(135deg, var(--mc-purple) 0%, var(--mc-purple-2) 100%);
  color: #fff !important;
  border-color: transparent;
  box-shadow: 0 4px 14px rgba(123, 63, 228, 0.3);
}

.mc-filtros__dates-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.65rem 0.85rem;
  margin-bottom: 1rem;
}

.mc-filtros__date-col {
  flex: 1 1 160px;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.mc-filtros__date-lbl {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--mc-text-muted);
}

.mc-filtros__date-arrow {
  flex-shrink: 0;
  align-self: center;
  padding-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--mc-purple);
}

/* Controle fechado com altura fixa; grade do calendário usa .form-control dentro do menu */
.mc-filtros__datepicker.b-form-btn-label-control.form-control {
  height: 48px !important;
  min-height: 48px !important;
  max-height: 48px !important;
  border-radius: var(--mc-radius-sm) !important;
  background: var(--mc-surface-soft) !important;
  border: 1px solid var(--mc-border) !important;
  padding: 0 !important;
  font-size: 0.9rem;
  color: var(--mc-text);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  overflow: visible !important;
}

.mc-filtros__datepicker.b-form-btn-label-control.form-control:focus-within {
  border-color: rgba(123, 63, 228, 0.55) !important;
  box-shadow: 0 0 0 3px rgba(123, 63, 228, 0.12) !important;
}

.mc-filtros__datepicker >>> label.form-control {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  height: 100% !important;
  min-height: 0 !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 0.75rem !important;
  font-weight: 600;
  border-radius: 0 var(--mc-radius-sm) var(--mc-radius-sm) 0 !important;
}

.mc-filtros__datepicker >>> .btn {
  border-radius: var(--mc-radius-sm) 0 0 var(--mc-radius-sm) !important;
  border: none !important;
  border-right: 1px solid var(--mc-border) !important;
  background: rgba(123, 63, 228, 0.1) !important;
  color: var(--mc-purple) !important;
  padding: 0 0.8rem !important;
}

.mc-filtros__datepicker >>> .btn:hover,
.mc-filtros__datepicker >>> .btn:focus {
  background: rgba(123, 63, 228, 0.16) !important;
  color: var(--mc-purple) !important;
}

.mc-filtros__datepicker >>> .dropdown-menu .form-control {
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
}

.mc-filtros__apply-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.mc-filtros__apply-btn {
  width: auto;
  border: none;
  border-radius: var(--mc-radius-sm);
  padding: 0.5rem 1.1rem;
  font-weight: 700;
  font-size: 0.875rem;
  cursor: pointer;
  background: linear-gradient(135deg, var(--mc-purple) 0%, var(--mc-purple-2) 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123, 63, 228, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}

.mc-filtros__apply-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(123, 63, 228, 0.34);
}

.mc-filtros__apply-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.mc-filtros__apply-spin {
  vertical-align: middle;
}
</style>

<!-- Popover do datepicker: z-index e altura da grade (menu-class no componente) -->
<style lang="scss">
.mc-filtros-datepicker-popover.dropdown-menu {
  z-index: 2505 !important;
  min-width: 288px;
  padding: 0.4rem;
  border-radius: 18px !important;
  border: 1px solid #e4daf0 !important;
  box-shadow: 0 16px 48px rgba(80, 45, 120, 0.16) !important;
}

.mc-filtros-datepicker-popover .b-calendar-grid.form-control {
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
}

.mc-filtros-datepicker-popover .b-calendar-header output,
.mc-filtros-datepicker-popover .b-calendar-header .form-control {
  height: auto !important;
  min-height: auto !important;
}

/* Datas sem “pastilha” de fundo (tema costuma pintar btn-outline-* / rounded-circle) */
.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn {
  background: transparent !important;
  background-image: none !important;
  border: none !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn.btn-outline-light,
.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn.btn-light {
  background: transparent !important;
  color: #3f3a52 !important;
}

.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn.text-muted {
  color: #9b94b0 !important;
}

/* Dia selecionado: só destaque discreto */
.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn.active.btn-primary,
.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn.btn-primary {
  background: rgba(111, 53, 208, 0.14) !important;
  color: #5e2bb8 !important;
}

/* Hoje (contorno fino, sem fundo cheio) */
.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn.btn-outline-primary {
  background: transparent !important;
  color: #6f35d0 !important;
  box-shadow: inset 0 0 0 1px rgba(111, 53, 208, 0.45) !important;
}

.mc-filtros-datepicker-popover .b-calendar-grid-body .col[data-date] > span.btn:hover:not(.disabled) {
  background: rgba(0, 0, 0, 0.05) !important;
}

.mc-filtros-datepicker-popover .b-calendar-grid-body .col.bg-light {
  background-color: transparent !important;
}
</style>
